import { render, staticRenderFns } from "./additionalInfo.vue?vue&type=template&id=7bd94285&"
import script from "./additionalInfo.vue?vue&type=script&lang=js&"
export * from "./additionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports